
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ResultsHero from './components/ResultsHero';
import MetricsSection from './components/MetricsSection';
import ProofSection from './components/ProofSection';

const ResultsPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <ResultsHero />
      <MetricsSection />
      <ProofSection />
      <Footer />
    </div>
  );
};

export default ResultsPage;
